// extracted by mini-css-extract-plugin
export default {"sectionwrapper":"Home_sectionwrapper__2lLxB","rmvbottomradius":"Home_rmvbottomradius__XcR2R","rmvtopradius":"Home_rmvtopradius__4Sr8m"};